import { useEffect } from "react";

type SeoOptions = {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  type?: "website" | "article";
  publishedTime?: string;
};

const upsertMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel: string, href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const useSeo = ({ title, description, keywords, image, type = "website", publishedTime }: SeoOptions) => {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", "index, follow");
    upsertMeta("name", "author", "考古坞");

    upsertMeta("property", "og:site_name", "考古坞");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    if (image) upsertMeta("property", "og:image", image);
    if (publishedTime) upsertMeta("property", "article:published_time", publishedTime);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    if (image) upsertMeta("name", "twitter:image", image);

    const canonical = window.location.origin + window.location.pathname;
    upsertMeta("property", "og:url", canonical);
    upsertLink("canonical", canonical);
  }, [title, description, keywords, image, type, publishedTime]);
};

export default useSeo;